module.exports = __webpack_public_path__ + "static/drag-logo-4ca3b39f9b92e6cabcae72a75cdf5d61.png";